import { Component, OnInit, Input } from '@angular/core';
import { Ceremony } from '../models/ceremony.model';
import { FireBaseService } from '../services/firebase.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { SlideNotifier } from '../models/slideNotifier.model';
import { Announcer } from '../models/announcer.model';
import { QuoteComponent } from '../components/quote/quote.component';
import { Quote } from '../models/qoute.model';
import { SlideShowModel } from '../models/slideshow.model';

declare var require: any

@Component({
    selector: 'ceremony',
    templateUrl: './ceremony.component.html',
    styleUrls: ['../app.component.css']
})

export class CeremonyComponent implements OnInit {
    model: Ceremony = new Ceremony();
    constructor(fbService: FireBaseService,
        private route: ActivatedRoute,
        private notifier: NotificationService) {
        this.route.params.subscribe(params => {
            let id = +params['id']; // (+) converts string 'id' to a number
            if (!id) {
                throw new Error("id is null");
            }
            fbService.getStore('Ceremonies', id).subscribe((dto) => {
                if (!dto) {
                    throw new Error("model is null");
                }   
                fbService.getDoc<SlideNotifier>(dto['slideNotifier'].path).subscribe((slideNotifier) => {
                    this.model.slideNotifier = slideNotifier;
                    this.notifier.notifySlide(this.model.slideNotifier);
                });
                fbService.getDoc<Announcer>(dto['announcer'].path).subscribe((announcer) => {
                    this.model.announcer = announcer;
                });
                fbService.getDoc<Quote>(dto['quote'].path).subscribe((quote) => {
                    this.model.quote = quote;
                });
                fbService.getDoc<SlideShowModel>(dto['slideshow'].path).subscribe((slideshow) => {
                    this.model.slideshow = slideshow;
                })
            });
        });

    }

    ngOnInit(): void {

    }
}


// WEBPACK FOOTER //
// ./src/app/ceremony/ceremony.component.ts